import { degToCompass, windColor, beaufort, beaufortLabel, minutesAgoLabel, sensorLage } from "../utils/wind";

const STATUS_DOT = { ok: "#22c55e", warning: "#eab308", offline: "#ef4444", unknown: "#64748b" };

function WindArrow({ deg }) {
  if (deg === null || deg === undefined) return null;
  return (
    <svg width="32" height="32" viewBox="0 0 32 32"
      style={{ transform: `rotate(${deg}deg)`, display: "inline-block", flexShrink: 0 }}>
      <polygon points="16,2 22,26 16,20 10,26" fill="#e2e8f0" stroke="#94a3b8" strokeWidth="1.5" />
    </svg>
  );
}

export default function WindCard({ sensor, onClick }) {
  const {
    sensor_name, floor, description, wind_speed, wind_gust,
    wind_direction, measured_at, minutes_ago, temperature, humidity,
    position_x, position_y
  } = sensor;

  const bft = beaufort(wind_speed);
  const color = windColor(wind_gust ?? wind_speed);
  const status = minutes_ago !== null && minutes_ago !== undefined
    ? (minutes_ago < 3 ? "ok" : minutes_ago < 10 ? "warning" : "offline")
    : "unknown";

  const isOffline = status === "offline" || status === "unknown";
  const lage = sensorLage(sensor);

  // Border-Farbe: bei Offline rot, sonst Wind-Farbcode
  const borderColor = isOffline ? "#ef4444" : color;

  return (
    <div style={{ ...styles.card, borderColor }} onClick={onClick}>
      {isOffline && (
        <div style={styles.offlineBanner}>
          <span style={styles.offlineIcon}>⚠</span>
          <span>Verbindung verloren</span>
        </div>
      )}

      <div style={styles.header}>
        <div style={styles.nameRow}>
          <span style={{ ...styles.dot, background: STATUS_DOT[status] }} />
          <span style={styles.name}>{sensor_name}</span>
          {floor && <span style={styles.floor}>Etage {floor}</span>}
        </div>
        {lage && <div style={styles.lage}>{lage}</div>}
        {description && <div style={styles.desc}>{description}</div>}
      </div>

      <div style={styles.mainRow}>
        <div style={styles.bigWind}>
          <span style={{ ...styles.bigVal, color: isOffline ? "#64748b" : color }}>
            {wind_speed !== null && wind_speed !== undefined ? wind_speed.toFixed(1) : "–"}
          </span>
          <span style={styles.unit}>m/s</span>
        </div>
        <div style={styles.dirBox}>
          <WindArrow deg={wind_direction} />
          <div style={styles.dirLabel}>{degToCompass(wind_direction)}</div>
        </div>
      </div>

      <div style={styles.row}>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Böe</div>
          <div style={{ ...styles.statVal, color: isOffline ? "#64748b" : color }}>
            {wind_gust !== null && wind_gust !== undefined ? wind_gust.toFixed(1) : "–"} m/s
          </div>
        </div>
        <div style={styles.statBox}>
          <div style={styles.statLabel}>Beaufort</div>
          <div style={styles.statVal}>{bft !== null ? bft : "–"}</div>
        </div>
        {temperature !== null && temperature !== undefined && (
          <div style={styles.statBox}>
            <div style={styles.statLabel}>Temp.</div>
            <div style={styles.statVal}>{temperature.toFixed(1)} °C</div>
          </div>
        )}
      </div>

      {bft !== null && !isOffline && (
        <div style={styles.bftLabel}>{beaufortLabel(bft)}</div>
      )}

      <div style={styles.footer}>
        {minutesAgoLabel(minutes_ago)}
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: "#1e293b", border: "2px solid #334155", borderRadius: 12,
    padding: 16, cursor: "pointer", transition: "transform 0.15s, box-shadow 0.15s",
    display: "flex", flexDirection: "column", gap: 8,
  },
  offlineBanner: {
    background: "#450a0a",
    color: "#fecaca",
    border: "1px solid #7f1d1d",
    borderRadius: 6,
    padding: "6px 10px",
    fontSize: 12,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 2,
  },
  offlineIcon: { fontSize: 14, color: "#ef4444" },
  header: {},
  nameRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 2 },
  dot: { width: 8, height: 8, borderRadius: "50%", flexShrink: 0 },
  name: { color: "#f1f5f9", fontWeight: 700, fontSize: 15 },
  lage: { color: "#e2e8f0", fontSize: 11, marginBottom: 2 },
  floor: {
    background: "#0f172a", color: "#94a3b8", fontSize: 11,
    borderRadius: 4, padding: "2px 6px", marginLeft: "auto",
  },
  desc: { color: "#64748b", fontSize: 12 },
  mainRow: { display: "flex", alignItems: "flex-end", gap: 12 },
  bigWind: { display: "flex", alignItems: "baseline", gap: 4 },
  bigVal: { fontSize: 42, fontWeight: 800, lineHeight: 1 },
  unit: { color: "#64748b", fontSize: 13 },
  dirBox: { marginLeft: "auto", textAlign: "center" },
  dirLabel: { color: "#94a3b8", fontSize: 12, marginTop: 2 },
  row: { display: "flex", gap: 8 },
  statBox: { flex: 1, background: "#0f172a", borderRadius: 8, padding: "6px 10px" },
  statLabel: { color: "#64748b", fontSize: 11 },
  statVal: { color: "#e2e8f0", fontSize: 14, fontWeight: 600 },
  bftLabel: { color: "#94a3b8", fontSize: 12, fontStyle: "italic" },
  footer: { color: "#475569", fontSize: 11, textAlign: "right" },
};
